import styled from 'styled-components'
import { textMuted } from '@/theme/colors'
import { fontSizes } from '@/theme/typography'
import { FieldError } from '@components/Field'

export const ErrorText = styled(FieldError)`
	display: block;
	margin: -8px 0 16px;
`

export const HintText = styled.div`
	color: ${textMuted};
	font-size: ${fontSizes.small};
	margin-top: -8px;
	margin-bottom: 16px;
`
